import type { CreateEventAttendeeInput } from "@tih/shared";

/** Parse bulk attendee lines: name, mobile, location, email (comma or tab separated). */
export function parseBulkAttendeeLines(text: string): CreateEventAttendeeInput[] {
  const rows: CreateEventAttendeeInput[] = [];
  for (const raw of text.split("\n")) {
    const line = raw.trim();
    if (!line) continue;
    const parts = line.split(/[,\t]/).map((p) => p.trim());
    const name = parts[0];
    if (!name) continue;
    rows.push({
      name,
      mobile: parts[1] || null,
      location: parts[2] || null,
      email: parts[3] || null,
    });
  }
  return rows;
}

export function formatCheckInTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
}
